import styled from 'styled-components';
import { resolve } from 'library/helpers/path-resolver';


export const BaseModalBody = styled.div((props) => `
  background: #FFFFFF;
  border-radius: .3em;
  box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.2);
  color: inherit;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  justify-content: flex-start;
  margin: auto;
  outline: none;
  overflow-y: auto;
  padding: 20px;
  position: relative;
  transition: all .125s ease-in-out;
  width: 100vw;

  @media (min-width: 1024px) {
    max-height: ${resolve(props.modalStyle, 'maxHeight', '650px')};
    max-width: ${resolve(props.modalStyle, 'maxWidth', '1100px')};
    width: 100%;
  }

  /* Devices less than 1024px) */
  @media (max-width: ${props.theme.screen.laptop}px) {
    border-radius: 0;
    overflow: auto;
  }
`);
